export default __webpack_public_path__ + "static/media/twitter.514d59ba.svg";